import { Box } from "@mui/material";
import ListView from "./ListView";
import React from "react";

const Dashboard = () => {
  return (
    <Box display={"flex"} justifyContent="center">
      <ListView />
    </Box>
  );
};

export default Dashboard;
